import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <p class="mb-5">
      В Русском театре премьера – «Сумерки богов». 
      Для тех, кто знает – тетралогия Вагнера. 
      Для большинства – гламурное название с целью завлечь. 
    </p>

    <p class="mb-3">
      А далее идёт краткое содержание: пьеса об А. Вертинском и В. Холодной. 
      О двух символах fin de siecle – утончённого, изысканного и изломанного декаденства конца Х1Х – начала ХХ века. 
      Фильмы Ханжонкова, «песенки» Вертинского – грустные, милые, такие берущие за сердце… 
      Эту душевную тонкость, интеллигентность в самом высшем смысле слова мало кто может передать. 
      Пел Вертинского славный БГ; пел красиво… но без души. 
      Пели и другие исполнители – и без души, и некрасиво. 
    </p>

    <p class="mb-3">
      Есть в Одессе изумительный артист – Алексей Семенищев. 
      В те ещё недавние времена, когда Дом Учёных был на самом деле оазисом культуры в нашем городе, 
      там ежемесячно устраивались концерты А. Семенищева; и несколько из них было посвящено только Вертинскому. 
      В одном из них артист выступил в костюме Пьеро, с атрибутами того времени; и мы увидели и услышали ПОДЛИННОЕ. 
      Это было настоящее проникновение в дух, стиль, душу давно ушедшей эпохи. 
    </p>

    <p class="mb-5">
      Концерты А. Семенищева были поставлены с тонким вкусом как маленькие спектакли, 
      и постоянная публика не пропускала ни одного его концерта. 
      Но сменилось начальство в Доме Учёных – и где теперь можно услышать Семенищева?
    </p>


    <p class="mb-3">
      Но увидеть «лунного Пьеро» можно – в спектакле Русского театра! 
      Вот он выскакивает на сцену и начинает балаболить. 
      Слова повторяются много раз, с заиканием – это, наверно, должно выражать душевное волнение великого артиста… 
      Его полуголость должна выражать обнажённость его души; а когда он, наконец, надевает верхнюю одежду, её болтающиеся рукава, 
      как у смирительной рубашки, являются намёком на некую ненормальность автора, не так ли? 
      (Разумеется, автора не пьесы, а песенок, слышимых за кадром).
    </p>

    <p class="mb-3">
      Кстати, о слышимости. 
      Я сидела в 4-ом ряду; голос актёра грохотал; но меня смутила некая бородавка на его правой щеке. 
      Я вообще-то думала, что с бородавками в актёры не берут… 
      а если она даже есть на лице, то от неё можно легко избавиться… 
      Но присмотревшись, я увидела, что это не бородавка, а крошечный микрофончик! 
    </p>

    <p class="mb-3">
      Не на стадионе, не во Дворце Спорта, а в небольшом ТЕАТРЕ, т.е. здании, специально построенном для того, 
      чтобы люди говорили со сцены, и их слышал весь зал. 
      Что, в театральных училищах перестали учить сценической речи? 
      На сцене непрофессионал?!
    </p>

    <p class="mb-3">
      Но Сергей Поляков прекрасно справляется со своей ролью в этом, фактически, моноспектакле; 
      он работает с полным драйвом и ведёт спектакль на едином дыхании. 
      Значит, это режиссёр решил подстраховаться и тем самым выдал свои сомнения в качестве своего продукта?
    </p>

    <p class="mb-3">
      А сомнения возникают и у нас: и от сомнительных голубых роз на сцене (наверное, режиссёр слыхал что-то о «Голубой розе», 
        да чуток перепутал времена и жанры), и от идиотического вида девицы, изрекающей цитаты из «Большой Советской Энциклопедии», 
        а потом претворяющейся в Веру Холодную. 
    </p>

    <p class="mb-3">
      А потом сомнения переходят в догадку: а ведь эти цитаты – не просто стёб, а в самом деле объяснение нынешней публике того, 
      чего она не знает! 
      Только завуалированное под стёб, чтоб легче проглотили. 
      И в самом деле – кто из молодых (для которых явно предназначен спектакль) знает сейчас, кто такой, например, Ф. И. Шаляпин? 
      Вот и объясняют, чтоб не совсем заскучали от непонятных слов.
    </p>

    <p class="mb-5">
      Тогда и длинные рассказы про кокаин становятся близки и понятны; особенно когда актёр, изображая надрыв декадентов, 
      срывается на блатной крик, как у незабвенного Промокашки у Говорухина. 
      Сейчас время Промокашек, а не Вертинских; и нужно быть понятным и близким публике.
    </p>

    <p class="mb-3">
      Только причём здесь Александр Вертинский, чьё лицо время от времени появляется на экране, 
      и чьи песенки со старых пластинок звучат таким диссонансом к происходящему на сцене?
    </p>

        
    
    `
  )
}

const itemName = {
  rus: `Промокашка в роли Бога`
}

const itemDate = {
  rus: `14 января 2007 г.`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemDate: itemDate.rus,
    itemAuthor: author.rus
  }
}

export default item;